// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";

// MARK: Stores
import GalleryStore from "../../../../stores/GalleryStore";
import { routerStore } from "../../../../stores/_rootStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	galleryStore: GalleryStore;
	match: Match<{ galleryId?: string }>;
}

@inject("galleryStore")
@observer
export default class GalleryCreateOrEdit extends React.Component<IProps> {
	public componentDidMount = async () => {
		const galleryId = this.props.match.params.galleryId;
		if (galleryId) {
			await this.props.galleryStore.getGallery(galleryId);
		}
	};

	public render() {
		const { galleryStore } = this.props;
		return (
			<div className="galleryCreateOrEdit">
				{!galleryStore.loading && (
					<div className="galleryCreateOrEditWrapper">
						<h1 className="galleryCreateOrEditTitle">{galleryStore.selectedGallery ? strings.gallery.createOrEdit.title.edit : strings.gallery.createOrEdit.title.new}</h1>
						<div className="galleryFormContainer">
							<h2>{strings.gallery.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.gallery.createOrEdit.fields.nick}
								name="nick"
								value={galleryStore.nick}
								onChange={galleryStore.handleValueChange}
								disabled={galleryStore.loading}
								required={true}
							/>
							<TextField
								label={strings.gallery.createOrEdit.fields.title}
								name="title"
								value={galleryStore.title}
								onChange={galleryStore.handleValueChange}
								disabled={galleryStore.loading}
								required={true}
							/>
							<TextField
								label={strings.gallery.createOrEdit.fields.description}
								name="description"
								multiline={true}
								value={galleryStore.description}
								onChange={galleryStore.handleValueChange}
								disabled={galleryStore.loading}
							/>
						</div>
						<Divider className="divider" />
						<ImageCase
							title={strings.gallery.createOrEdit.fields.imageTitle}
							onAddItem={galleryStore.imageService.selectSingleImage}
							onRemoveItem={galleryStore.imageService.removeImage}
							onReloadItem={galleryStore.imageService.reloadImage}
							imageUploaders={galleryStore.imageService.singleImageUploader}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => galleryStore.createOrEditGallery()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.gallery.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/gallery")}
							>
								{strings.gallery.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}
